"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Table = _interopRequireDefault(require("../Table"));

var _FlightsListing = require("./FlightsListing.proptypes");

var _FlightsOrdersCard = _interopRequireDefault(require("../FlightsOrdersCard"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/* eslint-disable react/prop-types */


var MainWrapper = _styledComponents.default.div.withConfig({
  displayName: "FlightsOrdersListing__MainWrapper",
  componentId: "sc-z2iamp-0"
})(["width:100%;border-collapse:collapse;"]);

var FlightsListing = function FlightsListing(props) {
  var theme = props.theme,
      accessible = props.accessible,
      customProperties = props.customProperties,
      isMobile = props.isMobile,
      data = props.data,
      dropdownOptionsProps = props.dropdownOptionsProps,
      onOptionSelect = props.onOptionSelect,
      translation = props.translation;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var tabIndex = !accessible ? '-1' : '0';

  var getMain = function getMain() {
    if (!isMobile) {
      return /*#__PURE__*/_react.default.createElement(MainWrapper, (0, _extends2.default)({
        tabIndex: tabIndex
      }, customProperties), /*#__PURE__*/_react.default.createElement(_Table.default, props));
    }

    return /*#__PURE__*/_react.default.createElement(MainWrapper, (0, _extends2.default)({
      tabIndex: tabIndex
    }, customProperties), data.map(function (flightData) {
      return /*#__PURE__*/_react.default.createElement(_FlightsOrdersCard.default, {
        key: "".concat(flightData.columns.bookingNumber, "+").concat(flightData.columns.origin, "+").concat(flightData.columns.destination),
        accessible: accessible,
        theme: theme,
        isMobile: isMobile,
        translation: translation,
        data: flightData,
        dropdownOptionsProps: dropdownOptionsProps,
        onOptionSelect: onOptionSelect
      });
    }));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

FlightsListing.propTypes = _FlightsListing.FlightsListingPropTypes.PropTypes;
FlightsListing.defaultProps = _FlightsListing.FlightsListingPropTypes.DefaultProps;
var _default = FlightsListing;
exports.default = _default;